import { Box, BoxProps, Typography, styled } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

export interface SurfaceProps extends BoxProps {
  title?: string;
  children?: ReactNode;
  noInnerPadding?: boolean;
  className?: string;
}

export const Surface = styled(
  ({
    title,
    children,
    noInnerPadding = false,
    className,
    ...boxProps
  }: SurfaceProps): ReactElement => {
    return (
      <Box
        borderRadius={20}
        p={20}
        pb={noInnerPadding ? 20 : 30}
        sx={{
          background: '#fff',
          boxShadow: '0 0 10px #e8e8e8',
          maxWidth: '100%',
        }}
        className={className}
        {...boxProps}
      >
        {title && (
          <Typography
            sx={{
              fontSize: { xs: '1em', md: '1.125em' },
              fontWeight: 600,
              marginBottom: { xs: 12, md: noInnerPadding ? 0 : 20 },
            }}
          >
            {title}
          </Typography>
        )}
        <Box pl={noInnerPadding ? 0 : 16} maxWidth="100%">
          {children}
        </Box>
      </Box>
    );
  },
)``;
